import React from 'react'
import Header from './components/Header';
import Footer from './components/Footer';
import { useState,useEffect } from 'react';
import './styles/motoStyles.css';
import lotus from '../src/images/lotus.png';

const DraftingTenders = () => {
  const [fadeOut, setFadeOut] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFadeOut(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

    
    useEffect(() => {
      const handleScroll = () => {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        
        if (scrollTop > 50) {
          setScrolled(true);
        } else {
          setScrolled(false);
        }
      };
    
      window.addEventListener("scroll", handleScroll);
      handleScroll();
    
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }, []);
  return (
    <div>
      <div className={`moto ${fadeOut ? 'fade-out' : ''}`}>
        <h1>Drafting Tenders here at KWA</h1>
      </div>
      <Header scrolled={scrolled}/>
      <div className='justify-content-center d-flex align-items-center w-100 fs-4' style={{minHeight:'100vh',padding:'10%',paddingTop: '5%',paddingBottom: '5%'}}>
        <img src={lotus} alt='' className='lotus'></img>
        <div className=''><p>Welcome to <span className="kwa">KWA</span>, where precision and expertise converge to meticulously construct
                legally robust tender documents, specifically tailored to fulfill the distinctive requirements of our
                clientele. We proudly present our specialized Tender Drafting Division, providing comprehensive and
                scrupulous drafting services meticulously crafted to accommodate the diverse needs of our esteemed clients.
                With an unwavering dedication to excellence and strict adherence to statutory mandates, our team adeptly
                navigates the intricacies of tender law with precision and efficacy.</p>
            <br />
            <p>At <span className="kwa">KWA</span>, we acknowledge the paramount importance of well-drafted tender documents in
                facilitating fair and transparent procurement processes. Our practice is rooted in a steadfast commitment to
                upholding the highest standards of legal integrity, ensuring that our clients' tender documents adhere to
                relevant legislation, including, but not limited to:</p>
            <p className='kwa'>
                The Indian Contract Act, 1872: Govern the formation and enforcement of contracts, stipulating fundamental
                elements such as offer, acceptance, consideration, and lawful object, crucial to tender agreements.
                <br />
                <br />
                The Indian Sale of Goods Act, 1930: Regulate the sale and purchase of goods in India, encompassing the
                terms and conditions permissible in tender documents pertaining to goods procurement.
                <br />
                <br />
                The General Financial Rules (GFR), 2017: Offer guidelines and procedures for government procurement in
                India, encompassing the preparation and submission of tender documents by government entities and
                contractors.
            </p>
            <br />
            <p>With a profound comprehension of these statutes and their ramifications, our team collaborates closely with
                clients to compose tender documents that are legally sound, compliant, and aligned with their strategic
                objectives. Whether it involves <span className="highlight">preparing bid proposals</span>, <span
                    className="highlight">drafting contractual terms and conditions</span>, or <span
                    className="highlight">structuring procurement agreements</span>, we provide tailored solutions aimed at
                safeguarding our clients' interests and optimizing their success prospects in the tendering process.</p>
            <br />
            <p>Reach out to us today to discover how <span className="kwa">KWA’s</span> Tender Drafting Services can assist you
                in confidently and effectively navigating the complexities of tender law in India.</p></div>
      </div>
      <Footer />
    </div>
  )
}

export default DraftingTenders
